import React,{useState, useEffect, Fragment} from "react";
import Select,{ components } from "react-select";
import TimePicker from "../../../components/TimePicker";
import "./index.css";

let times=[
]
let a = 0;
while(a<24){
    const hour = a.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false});
    times.push({label:hour+":00",value:{hh:a,mm:0}});
    times.push({label:hour+":15",value:{hh:a,mm:15}});
    times.push({label:hour+":30",value:{hh:a,mm:30}});
    times.push({label:hour+":45",value:{hh:a,mm:45}});
    a++;
}
let durations = [
    {label:"15min",value:15},
    {label:"30min",value:30},
    {label:"45min",value:45},
    {label:"60min",value:60}
];
var timeZoneFormatted = new Date().toString().match(/([A-Z]+[\+-][0-9]+.*)/)[1]
const Styles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: 250,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: 14,
  }),
};
const UserStyles = {
    control: (styles) => ({
        ...styles,
        backgroundColor: "white",
        width: "250px",
    }),
    option: (provided, state) => ({
        ...provided,
        fontSize: 14,
        display: "flex",
        flexDirection: "row",
        alignItems:"center"
    }),
  };
const { Option } = components;
const IconOption = props => (
    <Option {...props}>
      <div className="avatar"
        style={{backgroundImage:`url(${props.data.value.avatar_url||require("../../../assets/media/profile/avatar.png")})` }}
      />
      {props.data.label}
    </Option>
  );
const ScheduleModal = ({users,isDatePickable,schedule})=>{
    const [date, setDate] = useState(null);
    const [time, setTime] = useState(null);
    const [duration, setDuration] = useState(null);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [members,setMembers] = useState([]);
    const [member, setMember] = useState(null);
    useEffect(()=>{
        if(users)
            setMembers(users.map(user=>{
                return {value:user,label:user.firstname||"Unknown"}
            }));
        
    },[users])
    const onSchedule = ()=>{
        if(users!==false)
            schedule({user:member.value,time:time.value,duration:duration.value,title,description});
        else
            schedule({time:time.value,duration:duration.value,title,description,date:new Date(date)});
    }
    const Validate = ()=>{
        if(users!==false)
            return member&&time&&duration&&title&&description;
        else
            return time&&duration&&title&&description&&date;
    }
    const onChangeDate = ({target}) => {
        setDate(target.value);
      }
    return (
            <div
                className="modal fade schedule-meeting"
                id="schedule-meeting"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modal-default-fadein"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Schedule Meeting</h5>
                            <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            >
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        
                        <div className="modal-body pb-1 schedule-meeting-body">
                            <p className="title">
                                TIME ZONE: {timeZoneFormatted}
                            </p>
                            {users!==false&&<Fragment>
                                <p className="title">
                                    Select User
                                </p>
                                <div className="form-group">
                                    <Select
                                        value={member}
                                        components={{ Option: IconOption,DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                                        noOptionsMessage={()=>null}
                                        onChange={(value)=>setMember(value)}
                                        options={members}
                                        styles={UserStyles}
                                        placeholder="Members"
                                    />
                                </div>
                            </Fragment>}
                            <p className="title">
                                Select Time
                            </p>
                            <div className="form-group">
                                {isDatePickable&&
                                <input type="date" className="form-control" onChange={onChangeDate}
                                    value={date}
                                    style={{marginBottom:10}}
                                />}
                                <Select
                                    value={time}
                                    onChange={(value)=>setTime(value)}
                                    options={times}
                                    styles={Styles}
                                    placeholder="Time"
                                />
                            </div>
                            <p className="title">
                                Duration
                            </p>
                            <div className="form-group">
                                <Select
                                    value={duration}
                                    onChange={(value)=>setDuration(value)}
                                    options={durations}
                                    styles={Styles}
                                    placeholder="Duration"
                                />
                            </div>
                            <p className="title">
                                Title
                            </p>
                            <input
                                className="form-control form-control-md"
                                onChange={({target})=>setTitle(target.value)}
                                value={title}
                            />
                    
                            <p className="title">
                                Description
                            </p>
                            <textarea
                                maxLength="280"
                                className="form-control form-control-md"
                                onChange={({target})=>setDescription(target.value)}
                                value={description}
                            />
                            <p className="bottom-small-text">Max characters: 280</p>
                        
                            <div className="footer">
                            <button className="btn btn-green"
                                data-dismiss="modal"
                                onClick={onSchedule}
                                disabled={!Validate()}
                            >
                                Schedule
                            </button>
                            <button className="btn btn-orange"
                                data-dismiss="modal">
                                Later
                            </button>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
    );
}

export default ScheduleModal;



// WEBPACK FOOTER //
// ./src/screens/CalendarHub/ScheduleModal/index.js